import { useFormikContext } from 'formik'

import Button from '@/atoms/Button/Button'
import NativeSelect from '@/molecules/FormikFields/NativeSelect'
import PhoneField from '@/molecules/FormikFields/PhoneField'
import TextField from '@/molecules/FormikFields/TextField'
import { numEmployeesOptions } from './fields'
import countries from '@/utils/enums/countries'

interface Props {
  title?: string
  description?: string
  ctaTitle?: string
}

function GettingStarted({ title, description, ctaTitle }: Props): JSX.Element {
  const formik = useFormikContext()

  return (
    <section>
      <h1 className="h3 font-medium text-center | mb-2">{title}</h1>
      <p className="text-gray-60 text-center | mb-8">{description}</p>

      <div className="grid grid-cols-2 gap-2 | mb-4">
        <TextField name="first_name" placeholder="First Name" required />
        <TextField name="last_name" placeholder="Last Name" required />
      </div>

      <div className="mb-4">
        <TextField name="company" placeholder="Company Name" required />
      </div>

      <div className="mb-4">
        <NativeSelect
          name="numemployees"
          placeholder="Number of employees"
          options={numEmployeesOptions}
          required
        />
      </div>

      <div className="mb-4">
        <TextField name="email" placeholder="Email Address" required />
      </div>

      <div className="mb-4">
        <NativeSelect
          name="country"
          placeholder="Country"
          options={[
            { label: 'Country', value: '' },
            ...countries.map(i => ({ label: i.name, value: i.name }))
          ]}
          required
        />
      </div>

      <div className="mb-8">
        <PhoneField name="phone" placeholder="9990000000" required />
      </div>

      <Button
        htmlType="submit"
        type="primary"
        className="w-full | mb-8"
        loading={formik.isSubmitting}
      >
        {ctaTitle}
      </Button>

      <p className="text-small text-center text-gray-70">
        By signing up you agree to our&nbsp;
        <a
          className="text-blue-50"
          href="https://www.peppercontent.io/terms"
          target="_blank"
          rel="noreferrer"
        >
          Terms of Service
        </a>
        &nbsp;and&nbsp;
        <a
          className="text-blue-50"
          href="https://www.peppercontent.io/privacy"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
      </p>
    </section>
  )
}

export function CustomGettingStarted({
  title,
  description,
  ctaTitle
}: Props): JSX.Element {
  const formik = useFormikContext()

  return (
    <section>
      <h1 className="h3 font-medium text-center | mb-2">{title}</h1>
      <p className="text-gray-60 text-center | mb-8">{description}</p>

      <div className="grid grid-cols-2 gap-2 | mb-4">
        <TextField name="firstName" placeholder="First Name" required />
        <TextField name="lastName" placeholder="Last Name" required />
      </div>

      <div className="mb-4">
        <TextField name="company" placeholder="Company Name" required />
      </div>

      <div className="mb-4">
        <TextField name="designation" placeholder="Designation" required />
      </div>

      <div className="mb-4">
        <TextField name="email" placeholder="Email Address" required />
      </div>

      <div className="mb-4">
        <PhoneField name="phone" placeholder="9990000000" required />
      </div>

      <div className="mb-4">
        <NativeSelect
          name="numEmployees"
          placeholder="Number of employees"
          options={numEmployeesOptions}
          required
        />
      </div>
      <Button
        htmlType="submit"
        type="primary"
        className="w-full | mb-8"
        loading={formik.isSubmitting}
      >
        {ctaTitle}
      </Button>

      <p className="text-small text-center text-gray-70">
        By signing up you agree to our&nbsp;
        <a
          className="text-blue-50"
          href="https://www.peppercontent.io/terms"
          target="_blank"
          rel="noreferrer"
        >
          Terms of Service
        </a>
        &nbsp;and&nbsp;
        <a
          className="text-blue-50"
          href="https://www.peppercontent.io/privacy"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
      </p>
    </section>
  )
}

export default GettingStarted
